import './styles/main.css';

let headerInstance = null;
let blogListInstance = null;

const initTheme = () => {
  const theme = localStorage.getItem('blog_theme') || 'light';
  document.documentElement.setAttribute('data-theme', theme);
};

const renderApp = async () => {
  const { Header } = await import('./components/Header.js');
  const { Hero } = await import('./components/Hero.js');
  const { BlogList } = await import('./components/BlogList.js');
  const { Footer } = await import('./components/Footer.js');
  const postsModule = await import('./date/posts.js');

  headerInstance = new Header();
  const hero = new Hero();
  blogListInstance = new BlogList(postsModule.posts);
  const footer = new Footer();

  const appElement = document.getElementById('app');
  if (appElement) {
    appElement.innerHTML = '';
    
    const appHTML = `
      ${headerInstance.render()}
      ${hero.render()}
      ${blogListInstance.render()}
      ${footer.render()}
    `;
    
    appElement.innerHTML = appHTML;
  }

  headerInstance.initThemeToggle();
  blogListInstance.initReadHandlers();
  blogListInstance.initFilterHandlers();
};

initTheme();
renderApp();

if (import.meta.hot) {
  import.meta.hot.accept([
    './components/Header.js',
    './components/Hero.js',
    './components/BlogList.js',
    './components/Footer.js',
    './date/posts.js',
    './styles/main.css'
  ], async () => {
    console.log('Hot reload triggered, re-rendering...');
    await import('./styles/main.css');
    renderApp();
  });
}